'use client'

import './global.css'

export default function GlobalError() {
  return (
    <html>
      <body>
        <main className="flex h-screen flex-col items-center justify-center gap-3 text-center">
          <h1>Something went wrong</h1>
          <p>An unexpected error occurred. Please try again or return to the home page.</p>
          <a href="/">Go back</a>
        </main>
      </body>
    </html>
  )
}
